import React from 'react';
import { Wrench } from 'lucide-react';
import type { ArtifactViewerProps } from '../types';

export const StubViewer: React.FC<ArtifactViewerProps> = ({ artifact }) => (
  <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
    <div className="flex items-start gap-2">
      <Wrench className="h-4 w-4 text-amber-600 mt-0.5 shrink-0" />
      <div className="flex-1">
        <div className="text-sm font-medium text-amber-900">Anteprima non disponibile</div>
        <div className="text-xs text-amber-700 mt-1">
          Tipo <code>{artifact.kind}</code> non ancora supportato in questa build. Slug: <code>{artifact.slug}</code>.
        </div>
        <details className="mt-2 text-xs">
          <summary className="cursor-pointer text-amber-800">Mostra payload JSON</summary>
          <pre className="mt-1 p-2 bg-card border border-amber-200 rounded overflow-x-auto text-[11px]">
            {JSON.stringify(artifact.content, null, 2)}
          </pre>
        </details>
      </div>
    </div>
  </div>
);
